<script>
	import { onMount } from 'svelte';

	export let size = 12;

	async function refreshToken()
	{
		let url = `${atria.mainURL}/ShareLinkFix/instagram-token.asp`;
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		
		let data = await response.json()
		return data;
	}

	async function getFeed() 
	{
		let url = `${atria.mainURL}/ShareLinkFix/instagram.asp`;
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		
		let data = await response.json()
		return data;
	}

	function activateSlick() {
		const selector = '.posts'
		window.setTimeout(() => {            
			jQuery(selector).show();
			jQuery(selector).slick({
				infinite: true,
				speed: 1500,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: true,
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]            
			});
		}, 500);
	}

	$: feed = getFeed().then(json => {
		activateSlick();

		return json.data.slice(0, size);
	});

	onMount(async () => {
		await refreshToken();
	});
</script>

{#await feed}
Carregando
{:then data}
	<div class="posts">
		{#each data as post}
		<div class="post">
			{#if post.media_type == 'VIDEO'}
				<a href={post.permalink} target="_blank">
					<img src="{post.thumbnail_url}" alt="{post.caption}"  />
				</a>
			{:else}
				<a href={post.permalink} target="_blank">
					<img src="{post.media_url}" alt="{post.caption}" />
				</a>
			{/if}
		</div>
		{/each}
	</div>
{/await}

<style type="text/sass">
	@import 'public/assets/sass/variables.sass'

	.posts
		.post
			img
				height: 476px
				width: 100%
				object-fit: cover
</style>